import { states, country_list } from "../CatalogLocations/state"
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input, Select } from "../../../_metronic/_partials/controls";
import MultiSelect from "react-multi-select-component";
import * as _payments from "../CatalogPayments/operations"
// Validation schema
const CustomerEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is necesssary"),
  contact_name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is necesssary"),
  contact_email: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is necesssary"),
  contact_phone: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is necesssary"),
  payment: Yup.string()
    .max(50, "Maximum 50 symbols")
    .optional("Field is necesssary"),
  payment_time: Yup.string()
    .max(50, "Maximum 50 symbols")
    .optional("Field is Optional"),
  description: Yup.string().optional(),
  country: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .optional("Field is Optional"),
});

export function ClientEditForm({
  update,
  client,
  actionsLoading,
  handleClose,
}) {
  const [image, setImage] = useState(client.logo_url);
  const [payment, setPayment] = useState("")
  const [payments, setPayments] = useState([])
  useEffect(() => {
    _payments.getClients(setPayments)
  }, [])
  function resizedataURL(datas, wantedWidth, wantedHeight) {
    return new Promise(async function (resolve, reject) {

      // We create an image to receive the Data URI
      var img = document.createElement('img');

      // When the event "onload" is triggered we can resize the image.
      img.onload = function () {
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        // We set the dimensions at the wanted size.
        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

        const dataURI = canvas.toDataURL();

        // This is the return of the Promise
        resolve(dataURI);
      };

      // We put the Data URI in the image's src attribute
      img.src = datas;

    })
  }
  function updatePhoto({ target }) {
    const [file] = target.files;
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      ({ target }) => {
        resizedataURL(target.result, 100, 100)
          .then((data) => {
            setImage(data)
            client["logo_url"] = data
          })

      },
      false
    );
    if (file) {
      reader.readAsDataURL(file);
    }
  }
  const keys = Object.keys(states)
  const options = keys.sort().map(key => ({ label: key, value: key }))
  const initial = options.filter((option) =>
    (client.states || []).includes(option.value)
  );
  const [selected, setSelected] = useState(initial);
  const [isSubmitting, setSubmitting] = useState(false)
  const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  return (
    <>
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize={true}
        initialValues={client}
        validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          const selects = selected.map((selec) => selec.value);

          update({ ...client, ...values, states: selects, payment })
            .then(() => setSubmitting(false))
            .end((err) => {
              setSubmitting(false)
            })
        }}
      >
        {({ handleSubmit, errors, handleChange }) => (
          <>
            <Modal.Body className="cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  {/* First Name */}
                  <div className="col-lg-4 p-3">
                    <h6>Logo</h6>
                    <div className="col-lg-4 col-xl-6">
                      <div
                        className="image-input image-input-outline"
                        id="kt_profile_avatar"
                      >
                        <div
                          className="image-input-wrapper"
                          style={{
                            backgroundImage: `url(${image})`,
                          }}
                        ></div>
                        <label
                          className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                          data-action="change"
                          data-toggle="tooltip"
                          title=""
                          data-original-title="Change avatar"
                        >
                          <i className="fa fa-pen icon-sm text-muted"></i>
                          <input
                            type="file"
                            name="profile_avatar"
                            accept=".png, .jpg, .jpeg"
                            onChange={updatePhoto}
                          />
                          <input type="hidden" name="profile_avatar_remove" />
                        </label>
                        <span
                          className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                          data-action="cancel"
                          data-toggle="tooltip"
                          title="Cancel avatar"
                        >
                          <i className="ki ki-bold-close icon-xs text-muted"></i>
                        </span>
                      </div>
                      <span className="form-text text-muted">
                        Allowed file types: png, jpg, jpeg.
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <hr />

                    <h6 className="text-muted">Customer Information</h6>

                    <div className="form-group row">
                      <div className="col-lg-6">
                        <Field
                          name="name"
                          component={Input}
                          placeholder="Company Name"
                          label="Company Name"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-6">
                        <Field
                          name="description"
                          component={Input}
                          placeholder="Description"
                          label="Description"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>

                      <div className="col-lg-6">
                        <br />
                        <label>Select States</label>
                        <MultiSelect
                          name="states"
                          options={options}
                          value={selected}
                          onChange={setSelected}
                          labelledBy={"Select States"}

                        />
                      </div>

                      <div className="col-lg-6">
                        <br />
                        <label>Select Country</label>
                        <Select
                          name="country"

                        >
                          {country_list.map((country, key) => (
                            <option value={country} key={key}>
                              {country}
                            </option>
                          ))}
                        </Select>
                      </div>
                      <div className="col-lg-6">
                        <br />
                        <label>Payment type</label>
                        <Select name="payment" onChange={({ target }) => setPayment(target.value)}>
                          <option>
                            -null-
                          </option>
                          {["credit", "cash"].map((payment, key) => (
                            <option value={payment} key={key}>
                              {payment}
                            </option>
                          ))}
                          {payments.map((payment) => (
                            <option value={payment.name} key={payment.uid}>
                              {payment.name}
                            </option>
                          ))}
                        </Select>
                      </div>
                      {(client.payment || payment) === "credit" &&
                        (<div className="col-lg-6">
                          <br />
                          <label>Payment Time (Days)</label>
                          <Select name="payment_time">
                            <option>
                              -null-
                          </option>
                            {["3", "5", "10", "15", "30"].map((payment, key) => (
                              <option value={payment} key={key}>
                                {payment}
                              </option>
                            ))}
                          </Select>
                        </div>)}
                    </div>
                    <hr />
                    <h6 className="text-muted">Contact Information</h6>
                    <div className="form-group row">
                      <div className="col-lg-6">
                        <Field
                          name="contact_name"
                          component={Input}
                          placeholder="Contact Name"
                          label="Contact Name"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-6">
                        <Field
                          name="contact_email"
                          component={Input}
                          placeholder="Contact Email"
                          label="Contact Email"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-6">
                        <br />
                        <Field
                          name="contact_phone"
                          component={Input}
                          placeholder="Contact Phone"
                          label="Contact Phone"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                    </div>
                    <hr />
                    <h6 className="text-muted">Corporate Contact Information</h6>
                    <div className="form-group row">

                      <div className="col-lg-6">
                        <Field
                          name="corporate_phone"
                          component={Input}
                          placeholder="corporate Phone"
                          label="corporate Phone"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-6">
                        <Field
                          name="corporate_email"
                          component={Input}
                          placeholder="Corporate Email"
                          label="Corporate Email"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                    </div>
                    <hr />
                    <h6 className="text-muted">Invoice Information</h6>
                    <div className="form-group row">
                      <div className="col-lg-6">
                        <Field
                          name="invoice_address"
                          component={Input}
                          placeholder="Invoice Address"
                          label="Invoice Address"
                          errors={errors}
                          handleChange={handleChange}
                          onInput={toInputUppercase}
                        />
                      </div>
                    </div>
                  </div>
                </div>

              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                onClick={() => {
                  setSubmitting(true)
                  handleSubmit()
                }}
                disabled={isSubmitting}
                className="btn btn-primary btn-elevate"
              >
                {isSubmitting ?
                  <div className="d-flex align-items-center">
                    <div className="mr-2">Loading...</div>
                    <div className="spinner spinner-white mr-10"></div>
                  </div> : "Save"}
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}

export function ClientEditModal(props) {
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        size="lg"
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>{props.client.uid ? "Edit Customer" : "New Customer"}</h1>
        </Modal.Header>

        <ClientEditForm {...props} />
      </Modal>
    </>
  );
}
export function ClienDeleteModal(props) {
  return (
    <>
      <Modal
        show={props.delete}
        onHide={props.hideDelete}
        size="lg"
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>Delete Customer</h1>
        </Modal.Header>
        <Modal.Body>
          Are you sure to permanently delete this <b>Customer</b>?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={props.hideDelete}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="submit"
            onClick={() => props.deleteClient(props.client.uid)}
            className="btn btn-danger btn-elevate"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
